import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import rootReducer from "../reducers/rootReducer"
import { safeGetJSON, safeGetStorageItem } from "../../utility/safeStorage"
/* import { messaging } from "firebase"
import { firebaseConfig } from "../../authServices/firebaseConfig" */


const middlewares = [thunk]
/* 
const firebaseApp = firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging(); */

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const storedUser = safeGetJSON("user", "", { removeInvalid: true })
const storedToken = safeGetStorageItem("token") || ""
const store = createStore(
  rootReducer,
  { auth: { login: { user: storedUser, token: storedToken} } },
  composeEnhancers(applyMiddleware(...middlewares))
)
/* 
messaging.onMessage((payload) => {
  console.log('Received Firebase message:', payload);
  store.dispatch({ type: 'SHOW_EVENTS', payload: payload.events });
}); */

export { store }
